module.exports = __webpack_public_path__ + "img/96.866e890f.jpg";